/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum AccessType {
  paid = 'paid',
  free = 'free',
  coming_soon = 'coming_soon',
  enrollment_closed = 'enrollment_closed',
  private = 'private',
  draft = 'draft'
}
